import auth from "../config/firebase";
import { getCookie } from "../cookies";
import apiClient from "./axiosClient";
import CreateSeekerConnectionResponse from "wwg-utilities/dist/dtos/create-seeker-connection.response";

const createTrainingConnectionRequest = async (
  seeker: string = '',
  program: string = '',
  status: string = '',
  institution: string,
  title: string,
  catalog: string[],
): Promise<CreateSeekerConnectionResponse> => {
  const token = (await auth.currentUser?.getIdToken()) || getCookie('token');

  return apiClient
    .post(
      `seeker-connections`,
      { seeker, program, status, institution, title, catalog },
      {
        headers: {
          'Authorization-WWG': `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data);
};

export default createTrainingConnectionRequest;